import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { OperativoService } from 'src/app/proceso-operativo/opeartivo.service';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { PdfService } from '../../../Directivas/PdfService';
import { Router } from '@angular/router';
import { EstatusProyecto } from 'src/app/shared/model/proceso/estadoProyecto';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { EvidenciaOportunidad } from 'src/app/shared/model/gestion-proyectos/evidenciasOportunidad';
import { SeguimientoOportunidadBaseComponent } from '../../seguimiento-oportunidad.component';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { ArchivosUtileriasService } from 'src/app/utilerias/service/archivo-utilerias.service';


// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas
import { MatListModule } from '@angular/material/list'; // FIX: para mat-selection-list / mat-list-option

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular


@Component({
    selector: "app-seguimiento-oportunidad-desarrollador",
    standalone: true,
    templateUrl: "./seguimiento-oportunidad-desarrollador.component.html",
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      NgxMatSelectSearchModule,
      MatDatepickerModule,
      MatListModule, // FIX
    ],
    styleUrls: ["./../../seguimiento-oportunidad.component.css"]
})
export class SeguimientoOportunidadDesarrolladorComponent extends SeguimientoOportunidadBaseComponent {
  contenido: any;
  nombreFile: string;
  @ViewChild("downloadDocument") private download: ElementRef;
  recursosDesarollo: Empleado[];
  datosOportunidad: Proyecto = new Proyecto();
  titulo: string = "";
  tituloComentario: string = "";
  
 
  
  listaEstimacionGuardada: EvidenciaOportunidad[] = [];
  listaArchivosGralGuardada: EvidenciaOportunidad[] = [];
  isSubmitting: boolean = false;

  constructor(
    protected service: OperativoService,
    protected pdfService: PdfService,
    protected msg: Msg,
    protected dialog: MatDialog,
    protected sanitizer: DomSanitizer,
    private readonly router: Router,
    private readonly archivoService: ArchivosUtileriasService
  ) {
    super(service, pdfService, msg, dialog, sanitizer,archivoService);
  }

  ngOnInit() {
    this.datosOportunidad = JSON.parse(localStorage.getItem("datoProyecto"));
    if (this.datosOportunidad) {
      this.consultarComentarios(this.datosOportunidad.idGit);
      this.datosOportunidad.comentarios.forEach((element) => {
        element.estatus = EstatusProyecto[element.estado.toString()];
      });
      this.titulo = "SeguimientoDesarrollador";
      this.tituloComentario = "Comentario del Lider";
     

      this.datosOportunidad.archivos.forEach((file) => {
        let lowerCaseFileName = file.name.toLowerCase();

        if (this.regexFormatoEstimacion.test(lowerCaseFileName)) {
          this.listaEstimacionGuardada.push(file);
        } else {
          this.listaArchivosGralGuardada.push(file);
        }
      });
    }
  }

  regresar() {
    if (this.listaEstimacionAgregar.length > 0) {
      this.getConfirmacionRegresar()
        .fire()
        .then((resultado) => {
          if (resultado.isConfirmed) {
            this.router.navigate(["PROCESO/oportunidaddesarrollador"]);
          }
        });
    } else this.router.navigate(["PROCESO/oportunidaddesarrollador"]);
  }

  resourcesSelectedDevelopers(items: Array<Empleado>): void {
    this.recursosDesarollo = items;
  }

  guardarOportunidadDesarrollo() {
    this.datosOportunidad.comentarios = [];
    this.datosOportunidad.comentarios = this.listaComentarios;
    this.datosOportunidad.comentarios.forEach((element) => {
      var listaevidencia = [];
      if (element.archivosComentarios.length > 0) {
        element.archivosComentarios.forEach((datos) => {
          var evidenciasoportunidad = {
            name: datos.name,
            type: datos.type,
          };
          listaevidencia.push(evidenciasoportunidad);
        });
        this.datosOportunidad.archivos =
          this.datosOportunidad.archivos.concat(listaevidencia);
      }
    });

    if (this.listaEstimacionAgregar.length > 0) {
      var listaEvidenciaEstimacion = [];
      this.listaEstimacionAgregar.forEach((element) => {
        var evidenciasoportunidad = {
          name: element.name,
          type: element.type,
        };
        listaEvidenciaEstimacion.push(evidenciasoportunidad);
      });

      this.service.guardarArchivoGit(this.obtenerRequestFileForm(this.datosOportunidad.idGit,this.listaEstimacionAgregar)).subscribe();
      this.datosOportunidad.archivos = this.datosOportunidad.archivos.concat(listaEvidenciaEstimacion);
    }
    this.service
      .guardarOportunidadSeguimiento(this.datosOportunidad)
      .subscribe((respuesta) => {
        if (respuesta.pCodRetorno === "00000") {
          this.msg.showSuccessNotification(
            "top",
            "Oportunidad actualizada exitosamente"
          );
          this.router.navigate(["PROCESO/oportunidaddesarrollador"]);
        } else {
          this.msg.showErrorNotification(
            "top",
            "Ocurrió un problema al actualizar la oportunidad."
          );
        }
      });
  }
  

  enviarOportunidadDesarrollo() {
    // La estimación no es obligatoria: si no hay ninguna (ni por agregar ni ya guardada)
    // se pide confirmación antes de continuar con el envío.
    const sinEstimacion =
      this.listaEstimacionAgregar.length === 0 && this.listaEstimacionGuardada.length === 0;

    if (!sinEstimacion) {
      this.continuarEnvioOportunidad();
      return;
    }

    this.getConfirmacionSinEstimacion()
      .fire()
      .then((resultado) => {
        if (resultado.isConfirmed) {
          this.continuarEnvioOportunidad();
        }
      });
  }

  private continuarEnvioOportunidad() {
    this.getComentarioCambioEstado().fire({ title: "Enviar oportunidad a ODP" }).then((resultado) => {
      if (resultado.value) {
        if (this.listaEstimacionAgregar.length > 0) {
          this.service.guardarArchivoGit(this.obtenerRequestFileForm(this.datosOportunidad.idGit,this.listaEstimacionAgregar)).subscribe((res: any) => {
            if (res?.status && res.status === "ok") {
              if(this.datosOportunidad.archivos)
                this.datosOportunidad.archivos = this.datosOportunidad.archivos.concat(this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar));
              else
                this.datosOportunidad.archivos= this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar);

              this.enviarService(resultado.value);
            }
          });
        } else {
          this.enviarService(resultado.value);
        }

      }});
  }




  private enviarService(comentario:string) :void{
    if (this.isSubmitting) return;
    this.isSubmitting = true;
          this.service.enviarOportunidad(this.datosOportunidad).subscribe(
              (respuesta) => {
                if (respuesta.pCodRetorno !== "00000") {
                  this.msg.showErrorNotification("top","Ocurrió un problema al enviar la oportunidad.");
                } else {
                  this.msg.showSuccessNotification("top","Oportunidad enviada al departamento de ODP" );
                  this.guardarComentarioService(this.datosOportunidad,comentario );
                  this.router.navigate(["PROCESO/oportunidaddesarrollador"]);
                }
              },
              () => {}
            )
            .add(() => {
              this.isSubmitting = false;
            });
  }
}


